// extracted by mini-css-extract-plugin
export default {"option":"Option_option__-LAjv","correct":"Option_correct__P4VjY","incorrect":"Option_incorrect__bEuy7"};